module.exports = __webpack_public_path__ + "media/images/top/feature04-fbf8688bd45006a13b8ec412c3367d5f.jpg";